export default __webpack_public_path__ + "static/media/DisableIcon.6e2e09b4.svg";